var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorsUnlockedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,22v-8.3427734c0-0.8017578,0.3125-1.5556641,0.8789062-2.1220703L5.4140625,11H22v2h2V4c0-1.6542969-1.3457031-3-3-3 h-6.7578125c-1.0527344,0-2.0839844,0.4267578-2.828125,1.171875l-7.9492188,7.9492188 C2.5205078,11.0654297,2,12.3212891,2,13.6572266V22c0,1.6542969,1.3457031,3,3,3h11v-2H5C4.4482422,23,4,22.5517578,4,22z  M12.828125,3.5859375C13.2001953,3.2138672,13.7158203,3,14.2421875,3H21c0.5517578,0,1,0.4482422,1,1v5H7.4140625 L12.828125,3.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,21h-6v-2c0-1.1025391,0.8974609-2,2-2s2,0.8974609,2,2h2c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4v2 c-1.1025391,0-2,0.8974609-2,2v6c0,1.1025391,0.8974609,2,2,2h8c1.1025391,0,2-0.8974609,2-2v-6C30,21.8974609,29.1025391,21,28,21 z M28,29h-8v-6h1h7V29z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 25,
    width: 2,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorsUnlockedSmall);
export default __webpack_public_path__ + "static/media/doors-unlocked--small.c5feb401079bc2bcfd561d8ccb0adb3a.svg";
export { ForwardRef as ReactComponent };